module.exports = __webpack_public_path__ + "img/streamer.1d6f0f55.jpg";